import BaseReport from "./BaseReport"

export default class Shops extends BaseReport {
    constructor() {
        const reportUrl = '/backend/references/shops/'
        super(reportUrl)
    }
}
